<template>
	<svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="SVGRepo_bgCarrier" stroke-width="0" />
		<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
		<g id="SVGRepo_iconCarrier">
			<path d="M5 5L19 19M5 19L19 5" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</g>
	</svg>
</template>
